import useMerchantWebPortalAxios from "../../utils/axiosWeb";
import { useDispatch } from "react-redux";
import { settingBillsData, settingBillsObjectData } from "../../features/billsPageSlice";
import useResponse from "../../app/useResponse";

function useOgeroAPI() {
  const dispatch = useDispatch();
  const MerchantWebPortalAxios = useMerchantWebPortalAxios();
  const { successResponse, errorResponse } = useResponse();
  const errorRes = {
    response: {
      data: {
        isPopup: true,
        PopupTitle: "Error",
        PopupDescription: "Something went wrong. Please try again later.",
      },
    },
  };

  const OgeroLandLine = async (mobileNumber) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/ogero/landline`, {
        mobileNumber: mobileNumber,
      });
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));

      if (res.data.status) {
        if (res.data.data?.Popup) {
          successResponse(res.data.data.Popup);
        } else {
          dispatch(settingBillsObjectData({ mainField: "ogero", field: "MobileNumber", value: mobileNumber }));
          dispatch(settingBillsObjectData({ mainField: "ogero", field: "InvoiceId", value: res.data.data.invoiceId }));
          dispatch(settingBillsObjectData({ mainField: "ogero", field: "displayBill", value: res.data.data.displayBill }));
          dispatch(settingBillsObjectData({ mainField: "ogero", field: "LandlineReqId", value: res.data.data.LandlineReqId }));
          dispatch(settingBillsObjectData({ mainField: "ogero", field: "displayedFees", value: res.data.data.displayedFees }));
          dispatch(settingBillsData({ field: "currentPage", value: "payment-confirmation" }));
        }
        return res.data;
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const PayOgeroBill = async (payload) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/ogero/landline/pay`, payload);
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status && res.data.data !== -1) {
        return res.data;
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const OgeroAutoPay = async (userAccount, status) => {
    try {
        dispatch(settingBillsData({ field: "isloading", value: "loading" }));

        const res = await MerchantWebPortalAxios.post('/api/ogero/autopay', {
            userAccount: userAccount,
            status: status
        });

        return res.data;
    } catch (error) {
        dispatch(settingBillsData({ field: "isloading", value: "idle" }));
        console.error('OgeroAutoPay Error:', error);
        throw error;
    }
};


  return {
    OgeroLandLine,
    PayOgeroBill,
    OgeroAutoPay
  };
}

export default useOgeroAPI;
